import { useQuery } from "react-query";
import CategoryScreen from "..";
import Context from "../../../context";
import api from "../../../api";
import values from "../../../values";
import { useState } from "react";
import { TModal } from "../../../types/common.type";
import {
  ICreateAndUpdateCategory,
  IRequestCategory,
} from "../../../types/category.interface";
import utils from "../../../utils";

const CompanyContainer = () => {
  const [showModal, setShowModal] = useState<TModal>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] =
    useState<ICreateAndUpdateCategory>();
  const [requestCategory, setRequestCategory] = useState<IRequestCategory>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
  });

  const resultCategory = useQuery(
    [values.useQueryKeys.getAllCategory, requestCategory],
    () =>
      api.getMethod.common.findCategory({
        ...requestCategory,
      })
  );

  const updateCategory = async (category: ICreateAndUpdateCategory) => {
    setLoading(true);
    const result = await api.putMethod.common.updateCategory(category);
    if (result) {
      resultCategory.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      return false;
    }
  };
  const createCategory = async (CategoryInfo: ICreateAndUpdateCategory) => {
    setLoading(true);
    const result = await api.postMethod.common.createCategory(CategoryInfo);
    if (result) {
      resultCategory.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };
  const removeCategory = async (_id: string) => {
    setLoading(true);
    const result = await api.deleteMethod.common.deleteCategory(_id);
    if (result) {
      resultCategory.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };

  return (
    <Context.CategoryScreen.Provider
      value={{
        resultCategory,
        requestCategory,
        setRequestCategory,
        showModal,
        setShowModal,
        selectedCategory,
        setSelectedCategory,
        loading,
        setLoading,
        updateCategory,
        createCategory,
        removeCategory,
      }}
    >
      <CategoryScreen />
    </Context.CategoryScreen.Provider>
  );
};

export default CompanyContainer;
